import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  links: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
  },

  link: {
    fontSize: theme.spacing(1.75),
    letterSpacing: 0,
    color: theme.palette.action.hover,
    alignItems: 'center',
    padding: theme.spacing(2, 2),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: theme.spacing(12.5),

    '&:hover': {
      color: theme.palette.action.hover,
    },
  },

  icon: {
    color: theme.palette.action.hover,
  },
}));
